import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LeadershipSection = () => {
  const { t } = useLanguage();

  const leaders = [
    {
      ...t.leadership.ceo,
      image: 'https://www.sdtlab.it/assets/images/maria_rosaria.png',
      initials: 'MRS',
    },
    {
      ...t.leadership.cto,
      image: 'https://www.sdtlab.it/assets/images/stefano.png',
      initials: 'ST',
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-700 font-medium mb-4 block">{t.leadership.subtitle}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">{t.leadership.title}</h2>
        </div>

        {/* Leadership Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {leaders.map((leader, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-3xl overflow-hidden border border-gray-200 hover:border-amber-300 shadow-sm hover:shadow-xl transition-all duration-500"
            >
              {/* Image */}
              <div className="relative h-80 bg-gray-100 overflow-hidden">
                <img 
                  src={leader.image}
                  alt={leader.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'flex';
                  }}
                />
                {/* Fallback Avatar */}
                <div className="absolute inset-0 bg-amber-100 items-center justify-center text-amber-700 text-5xl font-bold hidden">
                  {leader.initials}
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-xl bg-amber-100 flex items-center justify-center text-amber-700 font-bold">
                    {leader.initials}
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-800">{leader.name}</h3>
                    <p className="text-amber-700 font-medium">{leader.role}</p>
                  </div>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {leader.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;